import County from './County';
import Tag from './Tag';

export default class Section {
    id: number;
    sectionNumber: number;
    abstractId: number;
    townshipId: number;
    townshipDescription: string;
    dlcNumber: number;
    tractCount: number;
    ownersCount: number;
    grossAcres: number;
    hbpAcres: number;
    openAcres: number;
    leasedAcres: number;
    westTexasCounties: { countyId: number; section: number }[];

    counties: Array<County>;
    addCounties: Array<County>;
    deleteCounties: Array<County>;
    tags: Array<Tag>;
    addTags: Array<Tag>;
    deleteTags: Array<Tag>;
}



// WEBPACK FOOTER //
// ./src/models/Section.ts